import React, { useEffect, useRef } from 'react';
import { Empty } from 'antd';
import { useLanguage } from '../../contexts/LanguageContext';
import ChatMessageBubble from './ChatMessageBubble';

/**
 * 訊息列表：渲染所有氣泡並自動捲到最新訊息。
 * visible 為 false 時跳過 scrollIntoView（避免 Modal 隱藏後觸發）。
 */
const ChatMessageList = ({ messages, activeSession, visible = true }) => {
  const { t } = useLanguage();
  const messagesEndRef = useRef(null);

  useEffect(() => {
    if (!visible) return;
    const node = messagesEndRef.current;
    if (node && typeof node.scrollIntoView === 'function') {
      node.scrollIntoView({ behavior: 'smooth', block: 'end' });
    }
  }, [messages.length, activeSession?.id, visible]);

  return (
    <div
      style={{
        flex: 1,
        overflowY: 'auto',
        overflowX: 'hidden',
        padding: 16,
        background: 'repeating-linear-gradient(45deg, #f5f5f5 0 2px, #fafafa 2px 8px)'
      }}
    >
      {messages.length === 0 ? (
        <div style={{ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <Empty
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            description={t('workflowMonitor.chatBotNoMessages') || '尚無對話訊息'}
          />
        </div>
      ) : (
        <>
          {messages.map((msg) => (
            <ChatMessageBubble key={msg.key} msg={msg} activeSession={activeSession} />
          ))}
          <div ref={messagesEndRef} />
        </>
      )}
    </div>
  );
};

export default ChatMessageList;
